<h2 mat-dialog-title>Action Prevented</h2>
<mat-dialog-content>
  <div class="dialog-content-container">
    <h3-sama-logo fillColor="samaGreen"></h3-sama-logo>
    <div class="subtitle-03">
      <p>
        Opening a task in multiple windows or tabs is not supported at this
        time. Please return to the original window or tab to continue
        annotating.
      </p>
      <p *ngIf="taskId$ | async">
        If you wanted to reach the read-only workspace, click
        <a [href]="getTaskUrl()">here</a>.
      </p>
      <p>
        Click
        <a
          href="https://docs.sama.com/docs/viewing-a-task-in-the-workspace-in-read-only-mode"
          >here</a
        >
        to learn more about how to access the read-only workspace.
      </p>
    </div>
  </div>
</mat-dialog-content>
@if (isMultipleTabsAllowed) {
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close color="error" (click)="trackEvent()">
      Proceed Anyway
    </button>
  </mat-dialog-actions>
}
